// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import constants from "@store/constants";
import {
    getViewNotesNotifications,
    toggleViewNotesNotifications,
} from "@store/Framework/Services/FeaturesNotificationService";
import React, { FC } from "react";
import { useEffect, useState } from "react";

export interface FeatureNotesListCheckboxProps extends WidgetProps {}

export interface FeatureNotesListCheckboxStyles {
    viewNotificationsCheckbox?: CheckboxProps;
}

export const featureNotesListCheckboxStyles: FeatureNotesListCheckboxStyles = {};

const styles = featureNotesListCheckboxStyles;

const FeatureNotesListCheckbox: FC<FeatureNotesListCheckboxProps> = () => {
    const [viewNotifications, setViewNotifications] = useState<boolean>(true);

    useEffect(() => {
        const viewNotificationsStorage = Boolean(getViewNotesNotifications());

        if (!viewNotificationsStorage) {
            setViewNotifications(false);
            return;
        }

        setViewNotifications(viewNotificationsStorage);
    }, [viewNotifications]);

    const viewNewFeaturesNotificationHandler = () => {
        toggleViewNotesNotifications();
        setViewNotifications(!viewNotifications);
    };

    return (
        <Checkbox
            {...styles.viewNotificationsCheckbox}
            onChange={viewNewFeaturesNotificationHandler}
            checked={viewNotifications}
            uid="viewNewFeaturesNotification"
        >
            {translate("View the New Features Notification on Homepage")}
        </Checkbox>
    );
};

const widgetModule: WidgetModule = {
    component: FeatureNotesListCheckbox,
    definition: {
        displayName: "Feature Notes List Checkbox",
        group: constants.widgetGroup.featureNotesList,
        allowedContexts: [constants.pageType.featureNotesList],
    },
};

export default widgetModule;
